import { PulseBaseProvider } from '../../base-classes';

const _coldFluCacheKey = 'coldFluStories';

// Cache for 1 hour
const cacheDurationMilliseconds = 60 * 60 * 1000;

export class ColdFluProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_coldFluCacheKey] = this.coldFluSyncer.bind(this);
    }

    async coldFluSyncer(params) {
        const { syncParams, resolve, reject, id } = params;
        let queryParams = {
            ...syncParams.stdParameters
            , verbose: syncParams.verbose
            , includeVideos: syncParams.includeVideos
            , recordsLimit: syncParams.recordsLimit
            , category: syncParams.category
        };
        return await super.syncData(syncParams.key, id, queryParams, syncParams.path, resolve, reject, null, syncParams.pulseApi, undefined, undefined, true, cacheDurationMilliseconds);
    }

    async getColdFluStories(stdParameters, path, verbose, category, includeVideos, recordsLimit ) {
        const syncParams = {
            verbose: !!verbose
            , path
            , category
            , includeVideos: !!includeVideos
            , recordsLimit
        };
        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        return await super.loadFromStorage(_coldFluCacheKey, id, syncParams);
    }
}
